import {ASync} from "../PA.Core/Basic/ASync";
import {IPolicy} from "../PA.Core/PA.Core.IF.Policy";
import {BehaviorSubject} from "rxjs";
import * as _ from 'lodash'
import {PAEnvironment} from "../PA.Core/PAEnvironment";
import {IUsrContext} from "../PA.Core/PA.Core.IF.User";
import {Role_TPM_Payment_Approver, Role_TPM_Payment_Editor} from "../PA.Core/Security/Roles";
import {PaymentBO} from "./PaymentBO";
import {WB_PaymentTypeRow} from "../PA.Core/PAdbSchemaRows";

export class PaymentBOStandardPolicy
    implements
        IPolicy
{
    _payment: PaymentBO
    _pmtType: WB_PaymentTypeRow
    _PolicyChanged: BehaviorSubject<IPolicy>
    _isApprover: boolean
    _isEditor: boolean
    _isClosedOrCancelled: boolean
    _isPostApproval: boolean
    _isPreApproval: boolean
    _isLoaded: boolean
 
    constructor(payment: PaymentBO) {
        this._payment = payment
        this._pmtType = payment.WB_Payment.WB_PaymentTypeRow
        this._PolicyChanged = new BehaviorSubject<IPolicy>(this)
        this._isApprover = false
        this._isEditor = false
        this._isClosedOrCancelled = false
        this._isPostApproval = false
        this._isPreApproval = false
        this._isLoaded = false

    }

    get OnLoadComplete(): Promise<void> {
        const self = this

        if(self._isLoaded){ return ASync.resolve() }
        let wbCustomerId = 0
        return new Promise<void>((resolve, error) => {
            self._payment.OnLoadComplete
                .then((ignore:any) => {
                    wbCustomerId = self._payment.WB_Payment.cif.WB_CUST_ID_FUNDING || self._payment.WB_Payment.cif.WB_CUST_ID_PLANNING
                    let currentState = self._payment.PrimaryWorkflowProcessor.CurrentState
                    self._isClosedOrCancelled =  currentState.StatusTypeClosed || currentState.StatusTypeCancelled
                    self._isPostApproval = currentState.StatusTypeIsPostApproval
                    self._isPreApproval = currentState.StatusTypeIsPreApproval

                    let usrContext: IUsrContext = PAEnvironment.getValue(PAEnvironment.UserContext)

                    if(usrContext){
                        let wbSalesOrgId = self._payment.WB_Payment.cif.WB_SALESORG_ID
                        let bInSalesOrg = _.some(usrContext.WB_SalesOrgs, (aSalesOrg) => aSalesOrg.cif.WB_SALESORG_ID === wbSalesOrgId)
                        let bCanAccessCustomer = _.some(usrContext.Customers, (aCustomer) => aCustomer.cif.WB_CUST_ID === wbCustomerId)

                        if(bInSalesOrg && bCanAccessCustomer){
                            self._isEditor =  usrContext.hasRoleId(Role_TPM_Payment_Editor, wbCustomerId)
                            self._isApprover = usrContext.hasRoleId(Role_TPM_Payment_Approver, wbCustomerId)
                        } else {
                            self._isApprover = false
                            self._isEditor = false
                        }
                    } else {
                        self._isApprover = false
                        self._isEditor = false
                    }
                    self._isLoaded = true
                    self._PolicyChanged.next(self)
                })
                .catch((err:any) => {
                    self._isApprover = false
                    self._isEditor = false
                    self._PolicyChanged.next(self)
                })
            //
            resolve()
        })
    }

    get bIsApprover(): boolean {
        return this._isApprover
    }

    get bIsEditor(): boolean {
        return this._isEditor
    }

    get bIsClosedOrCancelled(): boolean {
        return this._isClosedOrCancelled
    }

    get bIsPreApproval(): boolean {
        return this._isPreApproval
    }

    get bIsPostApproval(): boolean {
        return this._isPostApproval
    }

    // Add Editbility/ Visibility Properties for all the Elements of an Event
    get bNameEditable(): boolean{
        return this.bIsEditor && !this.bIsClosedOrCancelled
    }

    get bPlanningCustomerVisible(): boolean{
        return this._pmtType.bShowPlanningCustomer
    }


    get bSubPlanningCustomerEditable(): boolean {
        return this.bIsEditor && !this.bIsClosedOrCancelled
    }

    get bSubPlanningCustomerVisible(): boolean {
        return false
        // this._pmtType.bShow
    }


    get bWorkflowHistoryTabVisible(): boolean {
        return this.bIsPostApproval || this.bIsClosedOrCancelled
    }

    get PolicyChanged(): BehaviorSubject<IPolicy> {
        return this._PolicyChanged
    }

}


